/* eslint-disable @typescript-eslint/no-unused-vars */
import Box from "../Box";
import LogoCarrefour from "../../logo.svg";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { CIconButton, CText } from "@carrefour/design-system-components-react";
import { useDispatch } from "react-redux";
import { handleSidebar } from "../../slices/sideBarSlice";
import useBreakPoint from "../../utils/useBreakPoint";
import useDisplayHiddenMenu from "../../context/useDisplayHiddenMenu";

const BoxLogo = styled(Box)<StoreNameProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  transform: ${(props) =>
    props.$isScrolled ? "translate(0px, -9px)" : "translate(0,0)"};
  transition-timing-function: ease-in-out;
  transition: 500ms all ease;
`;

const ImgLogo = styled.img<StoreNameProps>`
  height: ${(props) => (props.$isScrolled ? "16px" : "36px")};
  animation-fill-mode: forwards;
  transition: height 500ms;
`;
const BoxDispear = styled(Box)<StoreNameProps>`
  opacity: ${(props) => (props.$isScrolled ? 0 : 1)};
  animation-fill-mode: forwards;
  transition: opacity 500ms;
`;

const TextReduce = styled(CText)<StoreNameProps>`
  font-size: ${(props) => (props.$isScrolled ? "13px" : "15px")} !important;
  animation-fill-mode: forwards;
  transition: font-size 500ms;
`;
const TextCustomColor = styled(CText)`
  color: #0970e6;
`;
const TextCustom = styled(CText)`
  color: #0e3368;
  font-weight: 700;
  width: 100px;
`;
type StoreNameProps = {
  $isScrolled: boolean;
};
type StoreNamePropsNew = {
  $isScrolled: boolean;
};
const StoreName = ({ $isScrolled }: StoreNamePropsNew) => {
  const dispatch = useDispatch();
  const currentView = useBreakPoint();

  const handleNav = () => {
    dispatch(handleSidebar());
  };

  const link = useDisplayHiddenMenu() ? 'dashboard' : 'commercial';

  return (
    <Box
      display={"flex"}
      px={currentView ==="phone" ? [0, 8] : ""}
      position={"relative"}
      data-testid="store-name"
      alignItems={"center"}
    >
      <Box pl={currentView ==="phone" ? [2, 4]: [2, 1]} pr={[1, 4]}>
        <CIconButton
          icon="menu"
          variation="transparent"
          tone={"accent"}
          size="m"
          onClick={handleNav}
        />
      </Box>
      <Link to={link} style={{ textDecoration: "none" }}>
        <BoxLogo $isScrolled={$isScrolled}>
          <ImgLogo
            src={LogoCarrefour}
            alt="Carrefour Logo"
            width={36}
            height={24}
            $isScrolled={$isScrolled}
          />
          <TextCustom role="testJest">Cockpit 360</TextCustom>
        </BoxLogo>
      </Link>
    </Box>
  );
};

export default StoreName;
